module.exports = __webpack_public_path__ + "static/media/march_new.021ea209.svg";